/**
 * @flow
 * @relayHash 1671b115585d1c9ad1e21759d34322ca
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteTagsInput = {|
  ids: $ReadOnlyArray<?string>,
  clientMutationId?: ?string,
|};
export type DeleteTagsMutationVariables = {|
  input: DeleteTagsInput
|};
export type DeleteTagsMutationResponse = {|
  +deleteTags: ?{|
    +isDeleted: ?boolean
  |}
|};
export type DeleteTagsMutation = {|
  variables: DeleteTagsMutationVariables,
  response: DeleteTagsMutationResponse,
|};
*/


/*
mutation DeleteTagsMutation(
  $input: DeleteTagsInput!
) {
  deleteTags(input: $input) {
    isDeleted
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteTagsInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteTags",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteTagsPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isDeleted",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteTagsMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteTagsMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteTagsMutation",
    "id": null,
    "text": "mutation DeleteTagsMutation(\n  $input: DeleteTagsInput!\n) {\n  deleteTags(input: $input) {\n    isDeleted\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b277da60b65de26b47687f8703522aba';
module.exports = node;
